import { useState } from 'react';
import { Moment } from 'moment';
import { LocalizationProvider, DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { convertToMoment } from 'utils/helpers/dateTimeHelper';

interface MomentDatePickerProps {
  showTime?: boolean;
  onSelect: (selectedValue: string | undefined) => void;
  currentValue: string | undefined;
  label?: string | undefined;
  name?: string | undefined;
  helperText?: React.ReactNode;
  error?: boolean | undefined;
  isDisabled?: boolean | undefined;
  isRequired?: boolean | undefined;
  allowPastDates?: boolean | undefined;
  preventFutureDates?: boolean | undefined;
  minDate?: string | undefined;
  maxDate?: string | undefined;
}

export const MomentDatePicker: React.VFC<MomentDatePickerProps> = (props) => {
  const {
    showTime,
    currentValue,
    label,
    onSelect,
    helperText,
    error,
    isDisabled,
    isRequired,
    allowPastDates,
    preventFutureDates,
    minDate,
    maxDate
  } = props;
  const [value, setValue] = useState<Moment | null>(convertToMoment(currentValue));

  const pickerProps = {
    disablePast: !allowPastDates,
    disableFuture: preventFutureDates,
    disabled: isDisabled,
    minDate: minDate ? convertToMoment(minDate) : undefined,
    maxDate: maxDate ? convertToMoment(maxDate) : undefined,
    label,
    value,
    onChange: (newValue: Moment | null) => {
      setValue(newValue);
      onSelect(newValue?.format());
    },
    slotProps: {
      textField: {
        helperText: helperText,
        error: error ? error : false,
        required: isRequired
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {showTime ? <DateTimePicker {...pickerProps} /> : <DatePicker {...pickerProps} />}
    </LocalizationProvider>
  );
};
